import CategoryArchiveSection from "components/Archive/CategoryArchiveSection"
import Meta from "components/Meta"
import { getGlobals, getArchive } from "storyblok/api"
import { getCategoryArchiveTeamMembers, getTeamMemberCategories } from "storyblok/teamMembers"
import TeamMemberCard from "components/TeamMemberCard"
import ArchiveHeader from "components/Archive/ArchiveHeader"
import { getCategoryArchiveTeamMembersApi } from "storyblok/teamMembersApi"
import { CardListSection } from "components/Archive/CardListSection"

export default function TeamMemberArchive({ meta, items, categories, story, currentPage, total, perPage }) {
  return (
    <>
      <Meta info={meta} />
      <main data-pagefind-body>
        <ArchiveHeader story={story?.content} breadcrumbs={[{ text: "Team Members", href: "/team-members" }]} />
        <CategoryArchiveSection
          categories={categories}
          archiveLink="/team-members"
          categoryLinkPrefix="/team-members/category/"
          currentTab={{ name: "All", value: "all" }}
          list={
            <CardListSection
              key="all"
              items={items}
              total={total}
              perPage={perPage}
              currentPage={currentPage}
              columns={4}
              handler={(params) => getCategoryArchiveTeamMembersApi(params)}
              Card={TeamMemberCard}
            />
          }
        />
      </main>
    </>
  )
}

export async function getStaticProps({ preview = null }) {
  const globals = await getGlobals()

  const story = await getArchive("team-members", preview)
  const categories = await getTeamMemberCategories()
  const { items, currentPage, total, perPage } = await getCategoryArchiveTeamMembers()

  return {
    props: {
      story: story ?? null,
      meta: story?.content?.twentysixty_seo ?? null,
      items,
      currentPage,
      total,
      perPage,
      categories: categories ?? null,
      globals: globals ?? null,
      preview,
    },
  }
}
